/**
 * [INPUT]: 依赖 CartesianRoot 结构根与 CartesianCanvas 连续序列绘制器
 * [OUTPUT]: 对外提供 AreaChart、LineChart 与支持双轴混合 series 的 ComboChart 组合根
 * [POS]: dither-kit 连续直角坐标入口，只决定家族类型而不定义 series
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { CartesianCanvas } from "./cartesian-canvas"
import { CartesianRoot } from "./cartesian-root";

/** Composable dither **area** chart. Compose `<Area>`, `<Grid>`, axes, … inside. */
export function AreaChart(props) {
  return <CartesianRoot chartType="area" Canvas={CartesianCanvas} {...props} />;
}

/** Composable dither **line** chart — `<Line>` series with a glow under the line. */
export function LineChart(props) {
  return <CartesianRoot chartType="line" Canvas={CartesianCanvas} {...props} />;
}

/** Composable dither combo chart — mixes `<Area>` and `<Line>` on left/right axes. */
export function ComboChart(props) {
  return <CartesianRoot chartType="combo" Canvas={CartesianCanvas} {...props} />;
}
